import React from "react";
import dynamic from "next/dynamic";
const Section = dynamic(() => import("@/Components/LayoutComponents/Section"),{ssr: true});
const QuoteForm = dynamic(() => import("./QuoteForm"), {
  ssr: false,
});

interface RFPFormProps {
  data?: any;
}

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";

const RFPForm: React.FC< RFPFormProps> = ({ data  }) =>  {
  return (
    <Section>
      <div className="container">
        <div className="max-w-[1230px] mx-auto text-center">
          <h2 className="text-heading-1 text-primary-text font-bold capitalize">
            {data?.title}
          </h2>
        </div>
        <div className="xl:mt-10 mt-[20px] sm:w-auto w-full">
          <div className="flex sm:flex-row flex-col justify-center items-center gap-[30px] mb-[40px] sm:w-auto w-full">
            {/* Blue Card */}
            {data?.schedule_call?.href && (
              <div className="h-full flex items-center justify-center cursor-pointer sm:w-auto w-full">
                <div
                  className="relative p-[24px] bg-blue-50 items-center flex gap-[8px] 
                  w-full justify-center sm:justify-end sm:flex-row flex-col
                  after:bg-[url(/images/blue-rfp.png)] after:content-[''] after:absolute lg:after:w-[58px] after:w-[44px] lg:after:h-[115px] after:h-[85px] after:max-h-[90%] after:top-0 after:right-0 after:bg-contain after:bg-no-repeat after:bg-right-bottom
                  before:bg-[url(/images/crm/blue-noise.png)] before:backdrop-blur-xs before:content-[''] before:absolute before:w-full before:h-full before:top-0 before:left-0 before:bg-cover before:bg-no-repeat before:bg-center"
                >
                  {/* Icon */}
                  <span className="h-[45px] w-[45px] flex bg-white relative  z-40">
                    <svg
                      width="45"
                      height="45"
                      viewBox="0 0 45 45"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      {data?.schedule_call?.image?.data?.attributes?.url ? (
                        <image
                          width="21"
                          height="21"
                          x="12.5"
                          y="12.5"
                          fill="white"
                          href={
                            baseUrl +
                            data?.schedule_call?.image?.data?.attributes?.url
                          }
                        />
                      ) : (
                        <>
                          <rect width="45" height="45" fill="white" />
                          <path
                            d="M31.775 33C29.3444 33 26.9382 32.475 24.5562 31.425C22.1743 30.375 20.0111 28.8778 18.0667 26.9333C16.1222 24.9889 14.625 22.8306 13.575 20.4583C12.525 18.0861 12 15.675 12 13.225V12H18.8833L19.9625 17.8625L16.6375 21.2167C17.0653 21.975 17.5417 22.6944 18.0667 23.375C18.5917 24.0556 19.1556 24.6875 19.7583 25.2708C20.3222 25.8347 20.9396 26.3743 21.6104 26.8896C22.2812 27.4049 23.0056 27.8861 23.7833 28.3333L27.1667 24.95L33 26.1458V33H31.775Z"
                            fill="#0086E6"
                          />
                        </>
                      )}
                    </svg>
                  </span>

                  {/* schedule call */}
                  <a
                    href={data?.schedule_call?.href}
                    target="_blank"
                    rel="noreferrer"
                    className="text-subtitle-1 font-bold text-primary-text text-center sm:text-left w-auto relative z-40"
                  >
                    {data?.schedule_call?.label}
                  </a>
                </div>
              </div>
            )}

            {/* Green Card */}
            {data?.contact_email?.href && (
              <div className="h-full flex items-center cursor-pointer sm:w-auto w-full">
                <div className="h-full flex items-center justify-center cursor-pointer sm:w-auto w-full">
                  <div
                    className="relative p-[24px] bg-green-50 items-center flex gap-[8px] 
                    w-full justify-center sm:justify-end sm:flex-row flex-col
                    after:bg-[url(/images/green-rfp.png)] after:content-[''] after:absolute lg:after:w-[58px] after:w-[44px] lg:after:h-[115px] after:h-[85px] after:max-h-[90%] after:top-0 after:right-0 after:bg-contain after:bg-no-repeat after:bg-right-bottom
                    before:bg-[url(/images/crm/green-noise.png)] before:backdrop-blur-xs before:content-[''] before:absolute before:w-full before:h-full before:top-0 before:left-0 before:bg-cover before:bg-no-repeat before:bg-center"
                  >
                    {/* Icon */}
                    <span className="h-[45px] w-[45px] bg-white flex relative z-40">
                      <svg
                        width="45"
                        height="45"
                        viewBox="0 0 45 45"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        {data?.contact_email?.image?.data?.attributes?.url ? (
                          <image
                            width="22"
                            height="22"
                            x="12.5"
                            y="11"
                            fill="white"
                            href={
                              baseUrl +
                              data?.contact_email?.image?.data?.attributes?.url
                            }
                          />
                        ) : (
                          <>
                            <rect width="45" height="45" fill="white" />
                            <path
                              d="M30.4 18.3333C29.4 18.3333 28.55 17.9769 27.85 17.2639C27.15 16.5509 26.8 15.6852 26.8 14.6667C26.8 13.6481 27.15 12.7824 27.85 12.0694C28.55 11.3565 29.4 11 30.4 11C31.4 11 32.25 11.3565 32.95 12.0694C33.65 12.7824 34 13.6481 34 14.6667C34 15.6852 33.65 16.5509 32.95 17.2639C32.25 17.9769 31.4 18.3333 30.4 18.3333ZM10 33V13.4444H24.52C24.44 13.8519 24.4 14.2593 24.4 14.6667C24.4 15.0741 24.44 15.4815 24.52 15.8889C24.66 16.5407 24.89 17.1468 25.21 17.7069C25.53 18.2671 25.92 18.7611 26.38 19.1889L22 22L12.4 15.8889V18.3333L22 24.4444L28.33 20.4111C28.67 20.5333 29.01 20.625 29.35 20.6861C29.69 20.7472 30.04 20.7778 30.4 20.7778C31.04 20.7778 31.67 20.6759 32.29 20.4722C32.91 20.2685 33.48 19.963 34 19.5556V33H10Z"
                              fill="#8ABC00"
                            />
                          </>
                        )}
                      </svg>
                    </span>

                    {/* Contact mail */}
                    <a
                      href={`mailto:${data?.contact_email?.href}`}
                      className="text-heading-6 font-bold text-primary-text text-center sm:text-left w-auto relative z-40"
                    >
                      {data?.contact_email?.label}
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div>

          <QuoteForm data={data} />
        </div>
      </div>
    </Section>
  );
};
export default RFPForm;